import angular from 'angular';
import leafletFactory from './leaflet.factory';
import leafletMapDirective from './leaflet-map.directive';

export default angular.module('pleaflet', [])
  .factory('L', leafletFactory)
  .directive('leafletMap', leafletMapDirective);



// WEBPACK FOOTER //
// ./src/app/screens/engineer/components/pleaflet/index.js